import Swiper, {Pagination} from 'swiper';
import 'swiper/css';
const selectors = {
  carouselWrapper: '[data-text-carousel]',
};
class TextCarousel extends HTMLElement {
  constructor() {
    super();
    this.initialise();
  }

  initialise() {
    const swiper = new Swiper(selectors.carouselWrapper, {
        modules: [Pagination],
        pagination: {
          el: '.text-carousel__swiper-pagination',
          clickable: true
        }
      });
  }
}
customElements.define('text-carousel', TextCarousel);